import { render, staticRenderFns } from "./limit_batch.vue?vue&type=template&id=baced580&"
import script from "./limit_batch.vue?vue&type=script&lang=js&"
export * from "./limit_batch.vue?vue&type=script&lang=js&"
import style0 from "./limit_batch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports